export const locale = {
  lang: 'pt',
  data: {
    MENU: {
      HOME: 'Upload',
      SAMPLE: 'Geocode',
      PROFILE: 'Profile',
      HISTORY: 'History'
    }
  }
}
